module.exports = __webpack_public_path__ + "img/swiper2.445a33fe.jpg";